import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'moderation-dialog',
    templateUrl: './moderation-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        MatDialogModule,
        TranslateModule,
    ]
})
export class ModerationDialogComponent {

  why: string = '';

}